import { useState as s, useEffect as c } from "react";
const u = () => {
}, l = (e, t, n) => n !== null && e > n ? n : t !== null && e < t ? t : e, a = (e) => {
  if (Math.abs(e) < 1 && Math.abs(e) !== 0) {
    const n = e.toExponential().split("e-"), r = n[0].split(".")[1];
    return (r ? r.length : 0) + parseInt(n[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}, p = (e, t, n) => {
  const r = Math.round((e - n) / t) * t + n;
  return Number(r.toFixed(a(t)));
}, i = new RegExp("[0-9]+(?:.[0-9]+)?(?=px)"), f = (e) => {
  if (i.test(e)) {
    const t = e.replace("px", "");
    return parseInt(t, 10);
  }
  return null;
}, h = (e) => ({
  shouldForwardProp: (t) => typeof t == "string" && !e.includes(t)
}), m = (e) => e.propNames ? e.propNames : [], g = () => Math.random().toString(36).slice(-6), M = () => {
  let e = !1;
  typeof window < "u" && (e = window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  const [t, n] = s(e);
  return c(() => {
    const r = window.matchMedia("(prefers-reduced-motion: reduce)"), o = () => {
      n(r.matches);
    };
    return o(), r.addEventListener("change", o), () => {
      r.removeEventListener("change", o);
    };
  }, []), t;
};
function w(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
export {
  l as clamp,
  f as convertPxStringToInt,
  h as filterProps,
  g as generateId,
  a as getDecimalPrecision,
  m as getStyledSystemPropNames,
  w as mergeRefs,
  u as noOp,
  p as roundValueToStep,
  M as useReducedMotion
};
